import React from 'react';
import cn from 'classnames';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import PostCompactCard from '../../../../PostCompactCard';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';

import s from './LatestPost.scss';

interface Props {
  block: RelatedBlock;
  deviation: PapiDeviation;
  className?: string;
}

const LatestPost: React.FC<Props> = ({ block, className }) => {
  const post = block.deviations?.[0];

  if (!post) {
    return null;
  }

  return (
    <div className={cn(s['post-card-wrapper'], className)}>
      <DeviationLink
        deviation={post}
        title={post.title}
        className={cn(s['post-card-link'], className)}
      >
        <PostCompactCard deviation={post} className={s['post-card']} showUsername={true} />
      </DeviationLink>
    </div>
  );
};

LatestPost.displayName = 'LatestPost';

export default LatestPost;
